import { requireStates, ConnectComponent2 } from "util";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";
import View from "./view";
import Presenter from "./presenter";

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);

const initialStates = [
  {
    name: "app.support.company",
    url: "/suporte/empresas",
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar,
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 100,
        name: "Empresas",
        state: "app.support.company"
      },
      authorization: context => context.user.is_admin
    }
  }
];

const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/support/company/index.js